import React from "react";
import { useTranslation } from "react-i18next";
import FindAvailableTime from "@features/search/components/FindAvailableTime";
import ResourceSearch from "@features/search/components/ResourceSearch";
import VStack from "@components/layout/VStack";
import TitlePage from "@components/layout/TitlePage";
import { titlePages } from "@shared/constants/appConstants";
import NavigateSearch from "@features/search/components/NavigateSearch";
import ResourceTypeToolbar from "@components/ui/ResourceTypeToolbar";
import { useResourceStore } from "@shared/stores";

const Search = () => {
  const { t } = useTranslation();
  const { filterResource } = useResourceStore();
  return (
    <VStack className="h-full">
      <VStack className="flex-1 px-4 pt-1 pb-4 overflow-hidden" gap={3}>
        {/* Title */}
        <TitlePage title={t(titlePages.search.title)} />

        {/* Resource Type */}
        <ResourceTypeToolbar selectedResourceType={filterResource?.resourceType} />

        {/* Component Search */}
        <div className="w-full flex-1 overflow-hidden">
          <ResourceSearch />
        </div>

        {/* Find Available Time */}
        <FindAvailableTime />
      </VStack>

      {/* Navigate Search */}
      <NavigateSearch isShowButtonSearch={false} />
    </VStack>
  );
};

export default Search;
